import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export default class CalendarApi {
    static reply(eventId, replierType, replierId, noChildren = '', noAdults = '', body) {
        return RESTClient.postAuthenticated('daycare/event/reply', {
            replierType,
            replierId,
            eventId,
            noAdults,
            noChildren,
            body,
        });
    }

    static create(institutionId, title, body, fromTime, toTime, recipients, rsvp, deadline, imageId, postToFeed) {
        return RESTClient.postAuthenticated('daycare/event/new', {
            institutionId,
            title,
            body,
            fromTime,
            toTime,
            recipients,
            rsvp,
            deadline,
            imageId,
            postToFeed,
        });
    }

    static createEvents(institutionId, recipients, events = []) {
        return RESTClient.postAuthenticated('v2/calendar', {
            institutionId,
            recipients,
            events,
        });
    }

    static updateEvent(
        institutionId,
        eventId,
        title,
        body,
        fromTime,
        toTime,
        recipients,
        rsvp,
        deadline,
        imageId = null,
        postToFeed,
    ) {
        return RESTClient.postAuthenticated('daycare/event/update', {
            institutionId,
            eventId,
            title,
            body,
            fromTime,
            toTime,
            recipients,
            rsvp,
            deadline,
            imageId,
            postToFeed,
        });
    }

    static deleteEvent(eventId) {
        return RESTClient.postAuthenticated('daycare/event/delete', {
            eventId,
        });
    }

    static showEvent(eventId) {
        return RESTClient.getAuthenticated('daycare/event/show2', {
            eventId,
        });
    }

    static getPossibleRecipients(institutionId) {
        return RESTClient.getAuthenticated('daycareadmin/recipients/event', {
            institutionId,
        });
    }

    static getCalendarLists() {
        return RESTClient.getAuthenticated('v2/calendar/list');
    }
}
